import actions from "../../actions";

const initialState = {
  id: -1,
  fetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.dashboard.suspend.SUSPEND_CLASS_REQUEST:
      return {
        id: action.id,
        fetching: true,
      };
    case actions.dashboard.suspend.SUSPEND_CLASS_SUCCESS:
      return {
        id: -1,
        fetching: false,
      };
    case actions.dashboard.suspend.SUSPEND_CLASS_ERROR:
      return {
        id: -1,
        fetching: false,
      };
    default:
      return state;
  }
};
